// extracted by mini-css-extract-plugin
module.exports = {"search":"JlySlvdV","searchText":"RRe2Mzyx","searchButton":"WCbnwtdv","links":"Brfvj3Gj","link":"wkGk2EGz","searchIcon":"_aR7hOfJ","authIframe":"cz_FCmQ7"};